import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 33 33"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M16.54 2.332c-7.732 0-14 6.268-14 14 0 6.565 4.52 12.074 10.618 13.587v-9.31H10.27v-4.278h2.887v-1.843c0-4.765 2.156-6.974 6.835-6.974.887 0 2.417.175 3.043.348v3.878c-.33-.035-.904-.052-1.617-.052-2.296 0-3.183.87-3.183 3.13v1.513h4.573l-.785 4.279h-3.788v9.62c6.933-.838 12.304-6.74 12.304-13.899 0-7.731-6.268-14-14-14Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }